import React, { FC } from 'react';

const MicIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="63"
    height="82"
    viewBox="0 0 63 82"
    className={className}
  >
    <g stroke="#1A1A1A" strokeWidth="2" fill="none" fillRule="evenodd">
      <path strokeLinecap="square" d="M31.85 70.31v8.64" />
      <path
        strokeWidth="2"
        d="M9.85.92a9.56 9.56 0 0 1 9.56 9.56v22.39a9.56 9.56 0 1 1-19.13 0v-22.4A9.56 9.56 0 0 1 9.85.93z"
        transform="translate(22 22.08)"
      />
      <g strokeLinecap="round">
        <path d="M22.6 80.08h19.16" />
        <path d="M46.35 48.03v7.17c0 7.93-6.5 14.35-14.5 14.35s-14.5-6.42-14.5-14.35v-7.17m39.82-1.45a30.05 30.05 0 0 0 4.22-15.39A30.2 30.2 0 0 0 1 31.2a30.05 30.05 0 0 0 4.22 15.4" />
        <path d="M11.77 40.03a21.23 21.23 0 0 1-1.93-8.84 21.35 21.35 0 1 1 40.77 8.84" />
      </g>
    </g>
  </svg>
);

export default MicIcon;
